<div class="skeleton-list">
    @for (item of itemArray; track $index) {
        <div class="skeleton-list__item skeleton" [style.height.px]="itemHeight"></div>
    }
</div>
